import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import Products from "@/pages/Products";
import Services from "@/pages/Services";
import WhyChooseUs from "@/pages/WhyChooseUs";
import FAQ from "@/pages/FAQ";
import ContactUs from "@/pages/ContactUs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="products" element={<Products />} />
              <Route path="services" element={<Services />} />
              <Route path="why-choose-us" element={<WhyChooseUs />} />
              <Route path="faq" element={<FAQ />} />
              <Route path="contact-us" element={<ContactUs />} />
            </Route>
          </Routes>
        </LanguageProvider>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
